import { alpha } from '@mui/material/styles';

import { MEDIUM_SOY } from 'reservations/brand/constants';

type DayStyles = {
  outsideCurrentMonth: boolean;
  selected?: boolean;
  today?: boolean;
  disabled?: boolean;
  isPastDate: boolean;
  isClosed: boolean;
  isAvailable: boolean;
  isUnavailable: boolean;
  primaryColor: string;
  backgroundColor?: string;
};

const defaultBadgeStyles = {
  width: '6px',
  height: '6px',
  borderRadius: '50%'
};
const defaultDayStyles = {
  color: 'white',
  border: 0
};

export function getDayStyles({
  outsideCurrentMonth,
  selected,
  today,
  disabled,
  isPastDate,
  isClosed,
  isAvailable,
  isUnavailable,
  primaryColor,
  backgroundColor = 'white'
}: DayStyles) {
  let dayStyles = null;
  let badgeStyles = null;

  const disabledColor = alpha(primaryColor, 0.4);

  if (isPastDate) {
    // Use a neutral gray for disabled/past dates for better visibility
    dayStyles = {
      ...defaultDayStyles,
      color: `${disabledColor} !important`
    };
    badgeStyles = null;
  } else if (isClosed && !disabled) {
    dayStyles = {
      textDecoration: 'line-through',
      color: `${disabledColor} !important`
    };
  } else if (selected && isAvailable) {
    dayStyles = {
      ...defaultDayStyles,
      background: primaryColor,
      color: backgroundColor
    };
  } else if (selected && isUnavailable) {
    dayStyles = {
      ...defaultDayStyles,
      background: `${disabledColor} !important`
    };
  } else if (isAvailable && !today && !outsideCurrentMonth && !disabled) {
    badgeStyles = {
      ...defaultBadgeStyles,
      background: primaryColor
    };
  } else if (isUnavailable && !today && !outsideCurrentMonth && !disabled) {
    badgeStyles = {
      ...defaultBadgeStyles,
      border: `1px solid ${MEDIUM_SOY}`
    };
  }
  return { dayStyles, badgeStyles };
}
